import Component from './Component';
import Styles from './Styles';

export const { ModalFooter } = Styles;
export default Component;
